module.exports = __webpack_public_path__ + "page13six-c3caa180013a30620ea6c13149ff7204.png";